import clsx from 'clsx';
import React, { ElementType } from 'react';

interface Props {
	className?: string;
	displayClass?: string;
	as?: ElementType<any>;
}

const ListItemTitle: React.FC<Props> = ({
  as = 'dt',
  className,
  displayClass = 'inline',
  children
}) => {
  const Tag = as;

  return (
    <Tag
      className={clsx(
        'font-semibold tracking-tighter uppercase whitespace-nowrap',
        displayClass,
        className
      )}
    >
      {children}
    </Tag>
  );
};

export { ListItemTitle as default };
